export enum ButtonStyle {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INFO = 'info',
  SUCCESS = 'success',
  WARN = 'warn',
  DANGER = 'danger'
}
